// extracted by mini-css-extract-plugin
export default {"wrapper":"SavedAddressEditor-module__wrapper___2HmLb","close":"SavedAddressEditor-module__close___1Q4_t"};